import axios from 'axios';

// 祝日データ（静的JSON）。形式: { "YYYYMMDD": "祝日名", ... }
// 取得元: /js/statics/holidays/{country}/{locale}/{year}.json （アプリ app-commin-app と同じ静的アセット）
// 多くの国は en のファイルしか持たないため、ロケール別ファイルが空/無い場合は en にフォールバックする
// （アプリ MonthlyCalendar.tsx の getHolidays と同挙動）。
const raw = {}; // key `${country}/${lang}/${year}` -> 取得済み生マップ（404 等は {}）
const rawPending = {}; // 同一キーの多重取得を防ぐ
const resolved = {}; // key -> en フォールバック適用後の最終マップ
const resolvedPending = {};

const keyOf = (country, lang, year) => `${country}/${lang}/${year}`;
const isEmpty = m => !m || Object.keys(m).length === 0;

// 単一ファイルの取得（キャッシュ＆多重取得防止）。失敗・不在は {} 扱い（再取得ループ防止）。
const fetchRaw = (country, lang, year) => {
  const key = keyOf(country, lang, year);
  if (raw[key] !== undefined) return Promise.resolve(raw[key]);
  if (rawPending[key]) return rawPending[key];

  // baseURL を空にしてページと同一オリジンの静的アセットを参照（モック時の :4010 等を回避）
  const url = `/js/statics/holidays/${country}/${lang}/${year}.json`;
  rawPending[key] = axios
    .get(url, { baseURL: '' })
    .then(res => {
      raw[key] = res.data && typeof res.data === 'object' ? res.data : {};
      delete rawPending[key];
      return raw[key];
    })
    .catch(() => {
      raw[key] = {};
      delete rawPending[key];
      return raw[key];
    });
  return rawPending[key];
};

/**
 * 取得済みなら最終（en フォールバック適用後）の祝日マップを返す。未取得なら null。
 */
export const getCachedHolidays = (country, lang, year) => {
  const m = resolved[keyOf(country, lang, year)];
  return m === undefined ? null : m;
};

/**
 * 祝日マップを取得（キャッシュ優先）。ロケール別ファイルが空かつ非 en の場合は en で補完する。
 */
export const loadHolidays = (country, lang, year) => {
  const key = keyOf(country, lang, year);
  if (resolved[key] !== undefined) return Promise.resolve(resolved[key]);
  if (resolvedPending[key]) return resolvedPending[key];

  resolvedPending[key] = fetchRaw(country, lang, year)
    .then(primary => {
      if (lang === 'en' || !isEmpty(primary)) return primary;
      // 空 & 非 en → en にフォールバック（祝日ファイルを持たない国/ロケール対策）
      return fetchRaw(country, 'en', year).then(en => (isEmpty(en) ? primary : en));
    })
    .then(final => {
      resolved[key] = final || {};
      delete resolvedPending[key];
      return resolved[key];
    });
  return resolvedPending[key];
};

export default { getCachedHolidays, loadHolidays };
